var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var OkDialogModal = require('../common/ok-message-dialog-with-action');
var ExacerbationsView = require('../medicals/exacerbations-view');

var MergeToPersonDiseasesView = Marionette.View.extend({
    template: require('../../templates/persons/merge-to-person-diseases-view.html'),

    regions: {
        exacerbationsShowRegion: '#exacerbation-show',
        comment: '#comment-content'
    },

    ui: {
        remove: '.remove',
        showExacs: '.show-exacs',
        showComment: '.show-comment',
        exacerbationShowModal: '#exacerbation-show-modal'
    },

    events: {
        'click @ui.remove': 'onRemoveRow',
        'click @ui.showExacs': 'onShowExacs',
        'click @ui.showComment': 'onShowComment'
    },

    templateContext: function () {
        var that = this;
        return {
            diseases: that.model.get('object').diseases || [],
            isMergedDisease: function(d) {
                return (that.modelCopyAsOriginal.get('object').diseases || []).filter(function(disease) {
                        return _.isEqual(disease, d);
                    }).length == 0;
            },
            mergeToPersonId: that.getOption('mergeToPersonId'),
            mergeToPersonName: that.getOption('mergeToPersonName'),
            formatDate: function(dt) {
                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
            },
            getTypeOfIdName: function(typeOfId) {
                return Dicts.hl7Dict[typeOfId] || typeOfId;
            }
        }
    },

    initialize: function (options) {
        this.model = options.model;
        this.modelCopyAsOriginal = options.modelCopyAsOriginal;
        this.utils = new CommonUtils();
    },

    onRender: function () {
        this.exacerbationsView = new ExacerbationsView({
            exacerbations: [],
            isReadOnly: true
        });
        this.showChildView('exacerbationsShowRegion', this.exacerbationsView);
    },

    onRemoveRow: function(event) {
        var uuid = event.target.id;
        var disease = _.findWhere(this.model.get('object').diseases, {uuid: uuid});
        this.triggerMethod('remove:person:diseases:row', disease);
    },

    onShowExacs: function(event) {
        console.log(event.target.id.replace('_', ''));
        var disease = _.findWhere(this.model.get('object').diseases, {uuid: event.target.id.replace('_', '')});
        this.exacerbationsView.resetCollection(disease.exacerbations || []);
        this.ui.exacerbationShowModal.modal('show');
    },

    onShowComment: function(event) {
        var disease = _.findWhere(this.model.get('object').diseases, {uuid: event.target.id.replace('__', '')});

        this.commentView = new OkDialogModal({
            title: 'Comment',
            message: disease.comment
        });

        this.showChildView('comment', this.commentView);
        this.commentView.show();
    }
});

module.exports = MergeToPersonDiseasesView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-to-person-diseases-view.js
// module id = 488
// module chunks = 0